/**
 * @fileoverview GET handler for the "/engagement/report_builder_2/:app_group_id/segment_analytics_tracking_windows" endpoint
 */
import fetch from "@lib/fetch";

import { createGetFetcherFunctionWithShadowError, reactQueryFetcherAdapter } from "../reactQueryFetcherAdapters";
import { engagementReportBuilder2AppGroupIdSegmentAnalyticsTrackingWindows } from "./constants";
import type {
  GetEngagementReportBuilder2AppGroupIdSegmentAnalyticsTrackingWindowsResult,
  SegmentAnalyticsTrackingWindowsErrors,
} from "./types";
import { isGetEngagementReportBuilder2AppGroupIdSegmentAnalyticsTrackingWindowsResult } from "./validators";

export const getEngagementReportBuilder2AppGroupIdSegmentAnalyticsTrackingWindows = reactQueryFetcherAdapter(
  engagementReportBuilder2AppGroupIdSegmentAnalyticsTrackingWindows,
  createGetFetcherFunctionWithShadowError<SegmentAnalyticsTrackingWindowsErrors>()(
    (
      signal: AbortSignal,
      appGroupId: string,
      segmentIds: string[]
    ): Promise<GetEngagementReportBuilder2AppGroupIdSegmentAnalyticsTrackingWindowsResult> => {
      return fetch(
        `/engagement/report_builder_2/${appGroupId}/segment_analytics_tracking_windows`,
        "GET",
        { segment_ids: segmentIds },
        { signal },
        { propagateFetchRequestError: false }
      );
    }
  ),
  isGetEngagementReportBuilder2AppGroupIdSegmentAnalyticsTrackingWindowsResult
);
